import React from "react";
import { getButtonClasses } from "../Inputs/inputUtility";

interface ExternalLinkAdapterProps {
    className?: string;
    describedById?: string;
    hasNoIcon?: boolean;
    isDownload?: boolean;
    label?: React.ReactNode;
    url?: string;
    opensInNewTab?: boolean;
    title?: string;
    handleClick?: () => void;
    [key: string]: unknown;
}

export const ExternalLink: React.FC<ExternalLinkAdapterProps> = (props) => <ExternalLinkAdapter {...props} />;

export const EmailLink: React.FC<{ address: string; className?: string; label?: React.ReactNode }> = (props) => {
    const { className, label, address } = props;
    const classes = className ? className : undefined;
    const newLabel = label ? label : address;

    return <ExternalLinkAdapter url={`mailto:${address}`} label={newLabel} opensInNewTab={false} hasNoIcon
        className={classes} />;
};

export const ExternalLinkButton: React.FC<ExternalLinkAdapterProps> = (props) => {
    let classes = getButtonClasses(props);

    return <ExternalLinkAdapter {...props} className={classes} />;
};

export const ExternalTertiaryLinkButton: React.FC<ExternalLinkAdapterProps> = (props) => {
    let classes = getButtonClasses({ ...props, isTertiary: true });

    return <ExternalLinkAdapter {...props} className={classes} />;
};

const getUrlLabel = (url: string) => <span aria-hidden='true'>{url.split('://')[1]}</span>;

export const ExternalLinkNoLabel: React.FC<{ className?: string; title: string; url: string }> = ({ className = "", title, url }) => {
    if (!title) return <></>;
    let label = getUrlLabel(url);

    return <ExternalLinkAdapter label={label} title={title} url={url} className={`break-all ${className}`} />;
};

const ExternalLinkAdapter: React.FC<ExternalLinkAdapterProps> = ({ className = "", describedById, hasNoIcon, isDownload, label, url,
opensInNewTab = true, title, handleClick = () => { } }: ExternalLinkAdapterProps) => {
    if (label && !url) return <>{label}</>;
    if (!label && !url) return <></>;

    const newTabTarget = opensInNewTab ? "_blank" : undefined;
    const newTabRel = opensInNewTab ? "noopener noreferrer" : undefined;
    let classes = className ? className : undefined;
    classes = hasNoIcon ? `${classes || ""} noIcon` : classes;

    return <span>  <a href={url} className={classes} target={newTabTarget} rel={newTabRel}
    title={title} aria-describedby={describedById} download={isDownload} onClick={handleClick}>{label}</a> </span>;
};
